import React, { forwardRef } from 'react';

import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { DateInput } from '@vlabs/uikit/components/controls/date-input/DateInput';
import { parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';

import st from './popovers.module.sass';
import { usePermissionTagsFilters } from '../usePermissionTagsFilters';

function DateFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const { filters, updateFilters } = usePermissionTagsFilters();

  return (
    <PopoverWithButton
      {...props}
      data-testid="create_time"
      onClickReset={() => updateFilters({
        create_time__gte: undefined,
        create_time__lt: undefined,
      })}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <DateInput
          enableTime
          id="create_time__gte"
          isClearable
          label={t('from_label') as unknown as string}
          name="create_time__gte"
          onChange={(dates: Date[]) => updateFilters({
            create_time__gte: dates?.[0]?.toISOString(),
          })}
          onClear={() => updateFilters({ create_time__gte: undefined })}
          options={START_OF_DAY}
          value={filters.create_time__gte ? parseISO(filters.create_time__gte) : ''}
        />
      </div>
      <div className={st.DateInputWrapper}>
        <DateInput
          enableTime
          id="create_time__lt"
          isClearable
          label={t('to_label') as unknown as string}
          name="create_time__lt"
          onChange={(dates: Date[]) => updateFilters({
            create_time__lt: dates?.[0]?.toISOString(),
          })}
          onClear={() => updateFilters({ create_time__lt: undefined })}
          options={END_OF_DAY}
          value={filters.create_time__lt ? parseISO(filters.create_time__lt) : ''}
        />
      </div>
    </PopoverWithButton>
  );
}

const DateFilterPopoverWithRef = forwardRef(DateFilterPopover);
export { DateFilterPopoverWithRef as DateFilterPopover };
